import SButton from "components/Common/Button"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import React from "react"
import { Row, Col, Spinner, Container, Card, CardBody } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { RadioGroup, Radio } from "react-radio-input"
import {
  getAuthor,
  getCraftsman,
  getUsersById,
  onCheckedCraftsman,
  udpateUsers,
} from "store/actions"
import Skeleton from "react-loading-skeleton"
import { useHistory, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import BackButton from "components/Common/BackButton"

const ModalEditUser = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  let { id } = useParams()

  const store = useSelector(({ Users }) => Users)
  const [field, setField] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    dispatch(getAuthor())
    dispatch(getCraftsman())
  }, [dispatch])

  React.useEffect(() => {
    setIsLoading(true)
    dispatch(getUsersById(id))
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [])

  const onChange = (e, i) => {
    setField({ ...field, authority: e.target.value })
    let { name, value } = e.target

    setField({ ...field, [name]: value })
  }
  const onChangeCraftsman = (e, i) => {
    let { checked } = e.target
    let args = { index: i, checked: checked }
    dispatch(onCheckedCraftsman(args))
  }

  const refetchData = () => {
    setField(null)
    history.push("/administrator")
  }

  const updateUser = () => {
    let payload = field
    let _craftsman = []
    store.craftsman.map(item => {
      if (item.isChecked) {
        _craftsman.push(item.label)
      }
    })
    payload.craftsmanTypes = _craftsman

    let args = { id: field.id, data: payload }
    dispatch(udpateUsers(args, refetchData))
  }

  React.useEffect(() => {
    if (Object.keys(store.dataById).length) {
      setField(store.dataById)
    }
  }, [store])

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"管理者"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            {isLoading ? (
              <div style={{ height: 180 }} className="p-3">
                <Skeleton height={30} />
                <div className="mt-3">
                  <Skeleton count={5} />
                </div>
              </div>
            ) : (
              <>
                <Row>
                  <Col md={8}>
                    <p className="fw-bold">管理者詳細</p>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    <SButton
                      onClick={updateUser}
                      disabled={store.status === "updating"}
                      className="button"
                    >
                      {store.status === "updating" ? (
                        <Spinner size="sm" color="light" />
                      ) : (
                        "保存"
                      )}
                    </SButton>
                    <BackButton className="ms-2 button" />
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <TextInputWithLabel
                      label={
                        <>
                          名前<span className="text-danger">*</span>
                        </>
                      }
                      placeholder={""}
                      type="text"
                      name="name"
                      onChange={onChange}
                      value={field?.name}
                    />
                  </Col>
                  <Col md="12" className="mt-3">
                    <TextInputWithLabel
                      label={
                        <>
                          メールアドレス<span className="text-danger">*</span>
                        </>
                      }
                      placeholder={""}
                      type="text"
                      name="email"
                      onChange={onChange}
                      value={field?.email}
                    />
                  </Col>
                  <Col md="12" className="mt-3">
                    <label className="form-label">権限</label>
                    {field ? (
                      <RadioGroup
                        className="d-flex"
                        name="authority"
                        onChange={value =>
                          setField({ ...field, authority: value })
                        }
                        selectedValue={field.authority}
                      >
                        {store?.author.map((item, i) => {
                          return (
                            <label
                              className="d-flex align-items-center me-2"
                              key={i}
                              htmlFor={`${item.label}Option`}
                            >
                              <Radio
                                id={`${item.label}Option`}
                                value={item.label}
                              />
                              <span className="ms-2">{item.label}</span>
                            </label>
                          )
                        })}
                      </RadioGroup>
                    ) : (
                      ""
                    )}
                  </Col>
                  {field ? (
                    <Col md="12" className="mt-3">
                      <label className="form-label">職人種類</label>
                      <div className="d-flex">
                        {store?.craftsman.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="d-flex align-items-center me-3"
                            >
                              <input
                                onChange={e => onChangeCraftsman(e, index)}
                                name="craftsmanTypes"
                                type="checkbox"
                                defaultChecked={item.isChecked}
                              />
                              <label className="form-label mb-0 ms-2">
                                {item.label}
                              </label>
                            </div>
                          )
                        })}
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default ModalEditUser
